import React from 'react';
// import logo from '../logo/swarovski-1.png';
// import logo from '../logo/logo.png';
import logo from '../logo/nimany logo.png';
import { BorderBottom, BorderLeft, BorderRight, BorderTop } from '@material-ui/icons';

const BillPrint = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px', // Adjust the top margin as needed
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px', // Adjust the top margin as needed
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
    };


    const cellStyleP = {
        BorderBottom: 'none',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        BorderBottom: 'none',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    
        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return num === 10 ? 'Ten' : teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };
    
        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };


    return (
        <div style={containerStyleN}>
            {/* Render your label content using the fetched data */}
            {labelData && (
                <div>
                    <div style={{ textAlign: 'center', marginBottom: '0px' }}>
                        <img src={logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto' }} />
                        {/* <h4 style={{ textAlign: 'center', marginBottom: '0px', marginTop: '1px' }}>Dealer : SWAROVSKI</h4> */}
                    </div>
                    
                    <h2 style={{ textAlign: 'center', marginBottom: '0px', marginTop: '0px' }}>{labelData.SalePrint.CompanyName}</h2>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>{labelData.SalePrint.AddressLine}</h5>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>Phone No:{labelData.SalePrint.ContactNumber1}</h5>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>Email:{labelData.SalePrint.Email}</h5>
                </div>

            )}

            {labelData && (
                <table style={tableStyle}>

                    <tr>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px' }}>State Code :{labelData.SalePrint.BranchStateCode}</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '40%', textAlign: 'center', marginTop: '0', marginBottom: '0' }}>
                            <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>CIN Number :{labelData.SalePrint.CINNumber}</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left', marginTop: '0', marginBottom: '0' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px' }}>Invoice Number :{labelData.SalePrint.BillPrefix}/SR/{labelData.SalePrint.BillNumber}/{labelData.SalePrint.FinYear}</h5>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px' }}>State Name :{labelData.SalePrint.BranchStateName}</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '40%', textAlign: 'center', marginTop: '0', marginBottom: '0' }}>
                            <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>GST Number :{labelData.SalePrint.CompanyGSTNumber}</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left', marginTop: '0', marginBottom: '0' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px' }}>Date :{new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })} </h5>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px' }}>Sale Bill No :{labelData.SalePrint.BranchStateName}</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '40%', textAlign: 'center', marginTop: '0', marginBottom: '0' }}>
                            {/* <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>GST Number :{labelData.SalePrint.CompanyGSTNumber}</h5> */}
                            <h4 style={{ textAlign: 'center', marginTop: '1px', marginBottom: '0px' }}>SALES RETURN</h4>
                        </td>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left', marginTop: '0', marginBottom: '0' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px' }}>Sale Bill Date :{new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })} </h5>
                        </td>
                    </tr>

                </table>
            )}
           

            {labelData && (
                <table style={tableStyle}>

                    <tr>
                        <td style={{ ...cellStyle, width: '100%', textAlign: 'left' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Customer Name & Address</h5>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.SalePrint.CustomerName}</h5>
                            {labelData.SalePrint.CustomerAddress ? (
                                <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.SalePrint.CustomerAddress}</h5>
                            ) : (
                                <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden' }}>Customer Address: Not Available</h5>
                            )}
                            {labelData.SalePrint.GSTNumber ? (
                                <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>GST Number: {labelData.SalePrint.CompanyGSTNumber}</h5>
                            ) : (
                                <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden' }}>GST Number: Not Available</h5>
                            )}

                        </td>
                    </tr>



                </table>
            )}

            {labelData && (
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <td style={{ ...cellStyle, width: '7%' }}>
                                <h5 style={{ marginTop: '4px', marginBottom: '2px' }}>CODE</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '42%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>DESCRIPTION</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '8%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>HSN</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '5%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>MRP</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '7%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>DISC %</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '4%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>QTY</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '8%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>RATE</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '7%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>GST %</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '7%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>GST</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '9%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>VALUE</h5>
                            </td>

                        </tr>
                    </thead>
                    <tbody>
                        {labelData &&
                            labelData.SalePrintDetails.map((record, index) => {
                                const isLastRecord = index === labelData.SalePrintDetails.length - 1;
                                return (
                                    <tr key={index} style={{ height: '20px' }}>

                                        <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.ItemCode}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '40%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '12px',
                                                    textAlign: 'left',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {record.ItemName}
                                                </label>
                                            </div>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '7%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.HSNCode}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '7%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.Rate !== 0 ? record.Rate : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '7%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.DiscountPercentage !== 0 ? record.DiscountPercentage : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '4%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.Quantity !== 0 ? record.Quantity : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.TaxableAmount !== 0 ? record.TaxableAmount : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.GSTRate !== 0 ? record.GSTRate : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '7%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.GSTAmount !== 0 ? record.GSTAmount.toFixed(2) : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '11%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.TotalAmount !== 0 ? record.TotalAmount.toFixed(2) : ''}
                                            </label>
                                        </td>

                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            )}

            {labelData && (
                <table style={tableStyle}>

                    <tr style={{ height: '20px' }}>
                        <td style={{ ...cellStyleL, width: '40%', textAlign: 'left' }}>
                            {labelData.SalePrint.IGSTAmount > 0 ? (
                                <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>
                                    IGST Amount: {labelData.SalePrint.IGSTAmount.toFixed(2)}
                                </h4>
                            ) : (
                                <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>
                                    CGST Amount: {labelData.SalePrint.CGSTAmount.toFixed(2)}
                                </h4>
                            )}
                        </td>

                        <td style={{ ...cellStyleN, width: '40%', textAlign: 'left' }}>
                            <h4 style={{ textAlign: 'right', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>TOTAL AMOUNT (Inclusive of GST)</h4>
                        </td>
                        <td style={{ ...cellStyleP, width: '20%', textAlign: 'left' }}>
                            <h4 style={{ textAlign: 'right', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>{labelData.SalePrint.GrandTotal.toFixed(2)}</h4>
                        </td>
                    </tr>

                    <tr style={{ height: '20px' }}>
                        <td style={{ ...cellStyleL1, width: '40%', textAlign: 'left' }}>
                            {labelData.SalePrint.IGSTAmount > 0 ? (
                                <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>

                                </h4>
                            ) : (
                                <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>
                                    SGST Amount: {labelData.SalePrint.SGSTAmount.toFixed(2)}
                                </h4>
                            )}
                        </td>

                        <td style={{ ...cellStyleN1, width: '40%', textAlign: 'left' }}>

                        </td>
                        <td style={{ ...cellStyleP1, width: '20%', textAlign: 'left' }}>

                        </td>
                    </tr>

                </table>
            )}
           
            {labelData && (
                <div>
                    <table style={tableStyle}>
                        <tr style={{ height: '55px' }}>
                            <td style={{ ...cellStyle, width: '70%', textAlign: 'left',height: '55px' }}>
                                <h4 style={{ marginTop: '5px', marginLeft: '10px', marginBottom: '2px' }}>
                                    <AmountInWords amount={labelData.SalePrint.GrandTotal} />
                                </h4>
                            </td>
                            <td style={{ ...cellStyle, width: '30%', textAlign: 'right' ,height: '55px'}}>
                                <h3 style={{ marginTop: '20px', marginLeft: '10px', marginBottom: '2px' }}>
                                    Authorised Signatory
                                </h3>
                            </td>
                        </tr>
                    </table>
                </div>
            )}
            
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 1px;
                        }
                    }
                `}
            </style>

        </div>
    );
};

export default BillPrint;
